export const PasswordInputsData = [
  {
    placeholder: 'Country',
    name: 'Country',
  },
  {
    placeholder: 'Date of Birth',
    name: 'date-of-birth',
  },
];

export const GenderSuggestionData = [
  {
    gender: 'male',
    name: 'gender',
    type: 'radio',
  },
  {
    gender: 'female',
    name: 'gender',
    type: 'radio',
  },
  {
    gender: 'other',
    name: 'gender',
    type: 'radio',
  },
];
